import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

export const downloadPageToPDF = (
  element: HTMLElement | null,
  fileName: string,
) => {
  if (element) {
    const style = document.createElement("style");
    document.head.appendChild(style);
    style.sheet?.insertRule(
      "body > div:last-child img { display: inline-block; }",
    );

    html2canvas(element, {
      scale: 4,
      useCORS: true,
      logging: false,
    }).then((canvas) => {
      style.remove();

      const imgData = canvas.toDataURL("image/jpeg");
      const pdf = new jsPDF("p", "mm", "a4");
      const imgWidth = 210;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      pdf.addImage(imgData, "JPEG", 0, 0, imgWidth, imgHeight);

      pdf.save(fileName);
    });
  }
};
